import React, { useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControlLabel,
  Switch,
} from '@mui/material';
import { Controller, useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as CategoryCreators } from 'store/categories/categories-duck.js';

const CategoryModal = ({
  isOpen,
  categoryToUpdate,
  categoriesCloseModal,
  categoriesCreateAsync,
  categoriesUpdateAsync,
}) => {
  const {
    register,
    handleSubmit,
    reset,
    control,
    formState: { errors, isSubmitting },
  } = useForm();

  useEffect(() => {
    if (isOpen) {
      reset(categoryToUpdate);
    }
  }, [isOpen, categoryToUpdate, reset]);

  const onSubmit = async (data) => {
    if (categoryToUpdate?.id) {
      categoriesUpdateAsync({ id: categoryToUpdate.id, ...data });
    } else {
      categoriesCreateAsync(data);
    }
    categoriesCloseModal();
  };

  return (
    <Dialog open={isOpen} onClose={categoriesCloseModal} fullWidth maxWidth="sm">
      <DialogTitle>{categoryToUpdate?.id ? 'Editar Categoria' : 'Nova Categoria'}</DialogTitle>
      <DialogContent>
        <TextField
          label="Nome"
          variant="filled"
          fullWidth
          margin="normal"
          error={!!errors.name}
          helperText={errors.name?.message}
          {...register('name', { required: 'O nome é obrigatório' })}
        />
        <Controller
          name="showOnMenu"
          control={control}
          defaultValue={categoryToUpdate?.showOnMenu || false}
          render={({ field: { onChange, value } }) => (
            <FormControlLabel
              control={
                <Switch checked={value} onChange={(event) => onChange(event.target.checked)} />
              }
              label="Mostrar no Menu Principal"
            />
          )}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={categoriesCloseModal} color="secondary">
          Cancelar
        </Button>
        <Button
          onClick={handleSubmit(onSubmit)}
          color="primary"
          variant="contained"
          disabled={isSubmitting}
        >
          Salvar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

const mapStateToProps = (state) => ({
  isOpen: state.Category.isModalOpen,
  categoryToUpdate: state.Category.categoryToUpdate,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(CategoryCreators, dispatch);
CategoryModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  categoryToUpdate: PropTypes.shape({
    id: PropTypes.number,
    name: PropTypes.string,
    showOnMenu: PropTypes.bool,
  }),
  categoriesCloseModal: PropTypes.func.isRequired,
  categoriesCreateAsync: PropTypes.func.isRequired,
  categoriesUpdateAsync: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(CategoryModal);
